import { Translation } from 'cng-common/features/translations/components/translation'

import { getFormedEltTranslation } from '../../../helpers/getFormedEltTranslation'

interface IProps {
  currentQuarter: number
  isFullYear?: boolean
}

export const FinancialSnapshotOutlookNote = ({ currentQuarter, isFullYear = false }: IProps) => {
  if (isFullYear) {
    return <Translation text={getFormedEltTranslation('note-full-year-is-actual')} />
  }
  if (currentQuarter === 1) {
    return <Translation text={getFormedEltTranslation('note-full-prev-year-is-actual')} />
  }
  if (currentQuarter === 2) {
    return <Translation text={getFormedEltTranslation('note-2-quarter-is-actual')} />
  }
  if (currentQuarter === 3) {
    return <Translation text={getFormedEltTranslation('note-3-quarter-is-actual')} />
  }
  if (currentQuarter === 4) {
    return <Translation text={getFormedEltTranslation('note-4-quarter-is-actual')} />
  }

  return null
}
